import {XauditModel} from '../xaudit.model';
import {OperatoryDataModel} from '../clients/operatory-data.model';

export class WorkstationConfigurationModel extends XauditModel {
  WorkStationId: string;
  LOCID: number;
  OperatoryId: string;
  WorkStationName: string;
  ComputerName: string;
  ComputerIP: string;
  cfgOperatory: OperatoryDataModel;
}
